namespace GeniuzPOS.Administration {
    export interface UserApprovalRoleRow {
        Id?: number;
        UserId?: number;
        ApprGroupCode?: string;
    }

    export namespace UserApprovalRoleRow {
        export const idProperty = 'Id';
        export const nameProperty = 'ApprGroupCode';
        export const localTextPrefix = 'Administration.UserApprovalRole';
        export const lookupKey = 'Administration.UserApprovalRole';

        export function getLookup(): Q.Lookup<UserApprovalRoleRow> {
            return Q.getLookup<UserApprovalRoleRow>('Administration.UserApprovalRole');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            UserId = "UserId",
            ApprGroupCode = "ApprGroupCode"
        }
    }
}
